let csrfParam = null
let csrfToken = null

export default function CSRFToken() {
  if (null == csrfToken || null == csrfParam) {
    const csrfParamElement = 'undefined' !== typeof document && document.head.querySelector('meta[name="csrf-param"]')
    if (csrfParamElement && csrfParamElement.content) {
      csrfParam = csrfParamElement.content
    }
    const csrfTokenElement = 'undefined' !== typeof document && document.head.querySelector('meta[name="csrf-token"]')
    if (csrfTokenElement && csrfTokenElement.content) {
      csrfToken = csrfTokenElement.content
    }
  }
  return [csrfParam, csrfToken]
}
